<script setup>
import Layout from "../../Components/Shared/LayoutAdmin.vue";
import UserForm from "../../Components/Forms/UserForm.vue";
import TableItem from "../../Components/Shared/TableItem.vue";
import ModalComponent from "../../Components/Shared/ModalComponent.vue";
import ButtonComponent from "../../Components/Shared/ButtonComponent.vue";
import { Link } from "@inertiajs/inertia-vue3";
import HeaderAdminComponent from "../../Components/Shared/HeaderAdminComponent.vue";

import { ref } from "vue";
import useApi from "../../Services/useApi";
import { Inertia } from "@inertiajs/inertia";
import useNotification from "../../Services/useNotification";

const props = defineProps(["users"]);
const modalTitle = ref("Crear");
const api = useApi();
const notificate = useNotification()
// users 
const initUser = {
    name: "",
    email: "",
    password: "",
    role_id: "",
};
const userToCreate = ref(initUser);
const userModal = ref(false)
const editUser = (user)  => {
    userToCreate.value = user;
    userModal.value = true;
    modalTitle.value = "Editar";
};
const deleteUser = (user) => {
    notificate.confirm("Seguro que quieres eliminar este usuario ?",()=>{
        api.deleteUser(user).then((response) => {
            console.log(response);
            notificate.success("Eliminado!");
            Inertia.reload();
        });
    })
};
const resetModals = () => {
    userModal.value = false;
};
</script>

<template lang="">
    <Layout>
        <HeaderAdminComponent title="Usuarios"></HeaderAdminComponent>
        <div class="container w-full mx-auto my-14 px-10">
            <ButtonComponent 
                content="Atrás" 
                :icon="'arrow_back_ios'"
                :link="'/admin'"
                type="2"
            />
            <ButtonComponent 
                content="Añadir nuevo usuario" 
                :icon="null"
                :link="null"
                type="0"
                @click="userModal = true" 
            />
            <div class="w-full my-10">
                <div class="flex w-full" v-for="item in users" :key="item.id">
                    <Link class="w-full" :href="'/category/'+item.id+'/fruits'">
                        <TableItem :items="[
                            { key: 'id', name: 'ID',value:item.id , width: '10%' },
                            { key: 'name', name: 'Nombre',value:item.name , width: '40%' },
                            { key: 'email', name: 'Email',value:item.email , width: '40%' },
                            { key: 'role_id', name: 'Rol',value:item.role_id==1?'Usuario':'Admin' , width: '10%' },
                        ]" /> 
                    </Link>
                    <div class="w-20 ml-6" v-if="$page.props.isAdmin==true">
                        <div class="flex pt-10">
                            <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/editar_enriqueto.svg" @click="editUser(item)" alt="">
                            <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/borrar_enriqueto.svg" @click="deleteUser(item)" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' un usuario'"
            v-model="userModal"
            v-if="userModal"
        >
            <UserForm @added="resetModals" :user="userToCreate" />
        </ModalComponent>
    </Layout>
</template>

<style lang="">
    
</style>